import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center">
      <ShieldAlert className="h-12 w-12 text-destructive" />
      <h1 className="text-2xl font-bold">Zugriff verweigert</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Für diesen Bereich fehlen die erforderlichen Berechtigungen. Bitte wenden Sie sich an die Administration.
      </p>
      <Button asChild>
        <Link to="/dashboard">Zurück zum Dashboard</Link>
      </Button>
    </div>
  );
}

